import React from 'react';
import { Link } from 'react-router-dom';
import PageSeo from './components/PageSeo';
import { useDarkMode } from './DarkModeContext';
import Footer from './Footer';

function Sitemap() {
    const { darkMode } = useDarkMode();
    
    const pages = {
        'Main': [
            { path: '/', name: 'Home' },
            { path: '/landing-page', name: 'Landing Page' },
            { path: '/use-cases', name: 'Use cases' },
        ],
        'Product': [
            { path: '/pricing', name: 'Pricing' },
            { path: '/about', name: 'About' },
            { path: '/contact', name: 'Contact' },
            { path: '/merra-or-manual', name: 'Merra or Manual?' },
            { path: '/merra-comparison', name: 'Merra Comparison' },
        ],
        'Use cases': [
            { path: '/ai-video-maker', name: 'AI video maker' },
            { path: '/ai-vlog-maker', name: 'AI vlog maker' },
            { path: '/ai-minivlog-maker', name: 'AI minivlog maker' },
            { path: '/ai-day-in-the-life-maker', name: 'AI day in the life maker' },
            { path: '/ai-get-ready-with-me-maker', name: 'AI get ready with me maker' },
        ],
        'Free tools': [
            { path: '/tiktok-shadowban-checker', name: 'TikTok shadowban checker' },
            { path: '/instagram-shadowban-checker', name: 'Instagram shadowban checker' },
            { path: '/when-to-post-tiktok', name: 'When to post on TikTok' },
            { path: '/when-to-post-instagram', name: 'When to post on Instagram' },
        ],
        'Company': [
            { path: '/career', name: 'Career' },
        ],
        'Content': [
            { path: '/news', name: 'News' },
            { path: '/b-roll-ideas', name: 'B-Roll Ideas' },
            { path: '/negotiation-brain-manifesto', name: 'The Negotiation Brain Manifesto' },
        ],
        'Legal': [
            { path: '/privacy-policy', name: 'Privacy Policy' },
            { path: '/terms-of-service', name: 'Terms of Service' },
            { path: '/confidentiality-rules', name: 'Confidentiality Rules' },
            { path: '/account-deletion', name: 'Request account deletion' },
        ],
    };
    
    return (
        <>
        <PageSeo
            title="Sitemap – Merra AI"
            description="Browse all pages on Merra AI: product, pricing, blog, legal, use cases, and company information."
            path="/sitemap"
        />
        <div style={{ 
            maxWidth: '1000px', 
            margin: '0 auto', 
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
            lineHeight: '1.6',
            color: darkMode ? '#e0e0e0' : '#333',
            backgroundColor: darkMode ? '#1a1a1a' : 'white',
            minHeight: '100vh'
        }}>
            <div style={{ marginBottom: '40px' }}>
                <h1 style={{ 
                    color: darkMode ? '#ffffff' : '#2c3e50', 
                    borderBottom: `2px solid ${darkMode ? '#4A9EFF' : '#3498db'}`, 
                    paddingBottom: '10px',
                    marginBottom: '30px'
                }}>
                    Sitemap
                </h1>
                <p style={{ 
                    fontSize: '16px',
                    color: darkMode ? '#e0e0e0' : '#666',
                    marginBottom: '40px'
                }}>
                    Find all pages and sections of our website below.
                </p>
            </div>

            {Object.entries(pages).map(([category, pageList]) => (
                <div key={category} style={{ 
                    marginBottom: '40px',
                    padding: '30px',
                    backgroundColor: darkMode ? '#2a2a2a' : '#f8f9fa',
                    borderRadius: '8px',
                    border: `1px solid ${darkMode ? '#444' : '#e0e0e0'}`
                }}>
                    <h2 style={{ 
                        color: darkMode ? '#ffffff' : '#2c3e50',
                        marginTop: 0,
                        marginBottom: '20px',
                        fontSize: '24px',
                        borderBottom: `1px solid ${darkMode ? '#444' : '#e0e0e0'}`,
                        paddingBottom: '10px'
                    }}>
                        {category}
                    </h2>
                    <ul style={{ 
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                        gap: '12px'
                    }}>
                        {pageList.map((page) => (
                            <li key={page.path}>
                                <Link 
                                    to={page.path}
                                    style={{
                                        color: darkMode ? '#4A9EFF' : '#1976d2',
                                        textDecoration: 'none',
                                        fontSize: '16px',
                                        display: 'block',
                                        padding: '8px 12px',
                                        borderRadius: '4px',
                                        transition: 'background-color 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = darkMode ? '#333' : '#e8f4f8';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    → {page.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}

            <div style={{ 
                marginTop: '40px',
                padding: '20px',
                backgroundColor: darkMode ? '#2a2a2a' : '#f8f9fa',
                borderRadius: '8px',
                border: `1px solid ${darkMode ? '#444' : '#e0e0e0'}`,
                textAlign: 'center'
            }}>
                <p style={{ 
                    color: darkMode ? '#e0e0e0' : '#666',
                    margin: 0,
                    fontSize: '14px'
                }}>
                    For search engines: <a 
                        href="/sitemap.xml" 
                        style={{ 
                            color: darkMode ? '#4A9EFF' : '#1976d2',
                            textDecoration: 'none'
                        }}
                    >
                        View XML Sitemap
                    </a>
                </p>
            </div>

            <Footer />
        </div>
        </>
    );
}

export default Sitemap;

